module.exports = __webpack_public_path__ + "static/media/VIP_Hour_Tile_3stars@3x.b5696d77.png";